export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Only run in production
  if (config.public.appEnvironment !== 'production') return;

  const region = config.public.appRegion || 'BE';

  const monetateSrc =
    region === 'NL'
      ? 'https://se.monetate.net/js/2/a-a77f9577/p/toolstation.nl/entry.js'
      : 'https://se.monetate.net/js/2/a-a77f9577/p/toolstation.be/entry.js';

  useHead({
    script: [
      {
        children: 'var monetateT = new Date().getTime();',
        type: 'text/javascript',
        tagPosition: 'head',
      },
      {
        src: monetateSrc,
        type: 'text/javascript',
        tagPosition: 'head',
      },
    ],
  });
});
